<script setup lang="ts">
import { computed } from 'vue';
import { ICON_PATHS } from './icon-paths';
import type { IconName } from './icon-paths';

/**
 * Контурная иконка из набора Lucide (ISC). Пути лежат в коде, а не в пакете:
 * нужно два десятка значков, тянуть ради них зависимость незачем.
 * Иконка декоративная — подпись всегда даёт текст рядом или aria-label кнопки.
 */
const props = withDefaults(defineProps<{ name: IconName; size?: number; strokeWidth?: number }>(), {
  size: 20,
  strokeWidth: 1.75,
});

const markup = computed(() => ICON_PATHS[props.name]);
</script>

<template>
  <!-- eslint-disable vue/no-v-html -- пути статичные, из ICON_PATHS -->
  <svg
    class="icon"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    :stroke-width="strokeWidth"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    focusable="false"
    v-html="markup"
  />
  <!-- eslint-enable vue/no-v-html -->
</template>

<style scoped>
.icon {
  flex-shrink: 0;
  display: block;
}
</style>
